<template>
  <div class="com">
    <div class="desc">
      You have activated
    </div>
    <div class="desc custom">
      <span class="kit-id">Kit ID #{{
            convertKitId(userInfo.kit_id)
          }}</span>
    </div>
    <p class="bottom-text">
      Please continue to submit your Sampling Details.
    </p>
    <div class="btn-wrap">
      <button class="btn" @click="switchStep">Continue</button>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { parseAndConvertKitId } from "../../mixins/parseAndConvertKitId";
export default {
  name: "Activated",
  mixins: [parseAndConvertKitId],
  data() {
    return {
      term_and_condition: false,
      sampling_detail: false
    };
  },
  computed: {
    ...mapGetters(["userInfo"])
  },
  methods: {
    switchStep() {
      this.$emit("nextStep", 1);
    }
  },
  created() {
    if (this.$route.query.step && !this.userInfo.collected_first_name) {
      this.$store.dispatch(
        "userInfo",
        this.$store.getters.userInfo.testkits[0]
      );
    }
  }
};
</script>

<style scoped lang="scss">
@import "../../../styles/colors";

.instructions-left {
  text-align: center;
  list-style: none;
  margin-top: 60px;
}
.desc {
  color: $gray;
  width: 100%;
  margin-top: 20px;
  line-height: 20px;
  text-align: center;
  font-size: 16px;
  font-family: TTNormsRegular, sans-serif;
}
.desc.custom {
  margin-top: 0px;
}
.kit-id {
	font-weight: bold;
}
.bottom-text {
  color: $gray;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
  font-family: TTNormsRegular, sans-serif;
  margin-top: 36px;
}
.btn {
  background-color: $green;
  width: 50%;
  margin: 36px auto 0 auto;
  max-width: 300px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: $white;
  cursor: pointer;
  outline: none;
  border: none;
  height: 45px;
  border-radius: 25px;
  transition: all 0.5s linear;
  font-size: 18px;
  font-family: TTNormsBold, sans-serif;
}
</style>
